import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en/translation.json";
import frTranslation from "./locales/fr/translation.json";
import enCheckout from "./app/_checkout/locales/en/checkout.json";
import frCheckout from "./app/_checkout/locales/fr/checkout.json";
import enServiceCall from "./app/service-calls/locales/en/service-call.json";
import frServiceCall from "./app/service-calls/locales/fr/service-call.json";
import enInvoicePay from "./app/invoices/[invoice]/pay/locales/en/invoice-pay.json";
import frInvoicePay from "./app/invoices/[invoice]/pay/locales/fr/invoice-pay.json";
import enContractUpdates from "./app/contract-updates/locales/en/contract-updates.json";
import frContractUpdates from "./app/contract-updates/locales/fr/contract-updates.json";
import enCaptureCard from "./app/capture-card/locales/en/capture-card.json";
import frCaptureCard from "./app/capture-card/locales/fr/capture-card.json";
import enClauses from "./app/clauses/locales/en/clauses.json";
import frClauses from "./app/clauses/locales/fr/clauses.json";
import enAppendices from "./app/appendices/locales/en/appendices.json";
import frAppendices from "./app/appendices/locales/fr/appendices.json";
import enDebugPanel from "./app/_debug-panel/locales/en/debug-panel.json";
import frDebugPanel from "./app/_debug-panel/locales/fr/debug-panel.json";
import enOccupants from "./app/occupants/locales/en/occupants.json";
import frOccupants from "./app/occupants/locales/fr/occupants.json";

const resources = {
  en: {
    translation: enTranslation,
    checkout: enCheckout,
    "service-call": enServiceCall,
    "invoice-pay": enInvoicePay,
    "contract-updates": enContractUpdates,
    "capture-card": enCaptureCard,
    clauses: enClauses,
    appendices: enAppendices,
    "debug-panel": enDebugPanel,
    occupants: enOccupants,
  },
  fr: {
    translation: frTranslation,
    checkout: frCheckout,
    "service-call": frServiceCall,
    "invoice-pay": frInvoicePay,
    "contract-updates": frContractUpdates,
    "capture-card": frCaptureCard,
    clauses: frClauses,
    appendices: frAppendices,
    "debug-panel": frDebugPanel,
    occupants: frOccupants,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: sessionStorage.getItem("language") ?? "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// The document is served as `lang="en"`, so a French-locale browser sees a page
// that misdeclares its language and offers to auto-translate it. Translating
// rewrites text nodes underneath React and blanks the page, so the declared
// language has to follow the one i18n is actually rendering.
const syncDocumentLanguage = (language: string) => {
  document.documentElement.lang = language;
};

syncDocumentLanguage(i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
